import { render, staticRenderFns } from "./ThePersonalOrdersPagination.vue?vue&type=template&id=90cf73e4&"
import script from "./ThePersonalOrdersPagination.vue?vue&type=script&lang=js&"
export * from "./ThePersonalOrdersPagination.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalOrdersPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports